import { ComponentPropsWithoutRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface ISelectRHFV2Option {
  value: string;
  label: string;
}

interface ISelectRHFV2Props extends ComponentPropsWithoutRef<"select"> {
  label?: string;
  options: ISelectRHFV2Option[];
  placeholder?: string;
}

export const SelectRHFV2 = forwardRef<HTMLSelectElement, ISelectRHFV2Props>(
  ({ label, options, placeholder, className, id, required, ...rest }, ref) => {
    return (
      <div className="relative w-full">
        {label && (
          <label
            htmlFor={id}
            className="absolute -top-[9px] left-4 z-10 flex bg-gradient-to-t from-white from-50% to-transparent to-50% px-1 text-xs text-[#2d2d2d]"
          >
            {label}
            {required && <span className="text-red-600">*</span>}
          </label>
        )}

        <select
          {...rest}
          id={id}
          ref={ref}
          required={required}
          className={twMerge(
            "h-11 w-full rounded-lg border border-solid border-[#2d2d2d] bg-white pl-3.5 pr-3.5 font-['Mulish'] text-base font-normal text-[#2d2d2d] focus:outline-none",
            className,
          )}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  },
);

SelectRHFV2.displayName = "SelectRHFV2";
